import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

const Plans = () => {

    useEffect(() => {
      document.title = "Plans - EAP Finance"; // Updated title
    }, []);
   
  const [amount, setAmount] = useState({
    beginners: '',
    advanced: '',
    premium: ''
  });

  const handleInputChange = (e, plan) => {
    setAmount({
      ...amount,
      [plan]: e.target.value
    });
  };

  const calculateROI = (investment, percentage) => {
    return (investment * percentage / 100).toFixed(2);
  };

  return (
    <>
    <div className="min-h-screen bg-white text-[#000300] pt-24 px-4 sm:px-6 lg:px-8">
    
      {/* Page Header - Added pt-20 to account for fixed header */}
      <div className="text-center mb-16 pt-20">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Investment Plans</h1>
        <p className="text-[#000300]/80 max-w-2xl mx-auto">
          Simple, transparent investment options with fixed returns
        </p>
      </div>

      {/* Plan Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {/* Basic Plan */}
        <div className="bg-white rounded-xl border border-[#000300]/10 overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
          <div className="p-8">
            <div className="flex justify-between items-start mb-6">
              <h3 className="text-2xl font-medium">BEGINNERS</h3>
              <span className="bg-[#000300]/5 text-[#000300]/90 px-3 py-1 rounded-full text-sm border border-[#000300]/10">
                ENTRY
              </span>
            </div>

            <div className="mb-6">
              <p className="text-[#000300]/60 mb-1">Investment Range</p>
              <p className="text-xl">$100 - $999</p>
            </div>

            <div className="flex justify-between items-center mb-6">
              <div>
                <p className="text-[#000300]/60">ROI Percentage</p>
                <p className="text-2xl">100%</p>
              </div>
              <div>
                <p className="text-[#000300]/60">Duration</p>
                <p>10 Days</p>
              </div>
            </div>

            <div className="mb-6">
              <p className="text-[#000300]/80 text-sm mb-3">
                Perfect for first-time investors. Example: Invest $200 and get $200 profit (100% ROI), totaling $400 returned after 10 days.
              </p>
            </div>

            <div className="mb-6">
              <div className="flex items-center justify-between mb-2">
                <label className="block text-[#000300]/60">Calculate Your Potential Return</label>
                <span className="text-xs bg-[#000300]/5 px-2 py-1 rounded">Try any amount!</span>
              </div>
              <div className="relative">
                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#000300]/50">$</span>
                <input
                  type="number"
                  value={amount.beginners}
                  onChange={(e) => handleInputChange(e, 'beginners')}
                  className="w-full bg-white border border-[#000300]/10 rounded-lg px-8 py-3 focus:ring-1 focus:ring-[#000300] focus:border-transparent placeholder-[#000300]/30"
                  placeholder="e.g. 200"
                />
              </div>
              {amount.beginners >= 100 && amount.beginners <= 999 ? (
                <div className="mt-3 p-3 bg-[#000300]/5 rounded-lg border border-[#000300]/10">
                  <p className="text-sm font-medium text-[#000300]">Your Calculation:</p>
                  <p className="text-sm mt-1">
                    <span className="font-medium">Investment:</span> ${amount.beginners}<br />
                    <span className="font-medium">Profit (100%):</span> +${calculateROI(amount.beginners, 100)}<br />
                    <span className="font-medium text-[#000300]">Total Return:</span> <span className="font-bold">${(+amount.beginners + +calculateROI(amount.beginners, 100)).toFixed(2)}</span>
                  </p>
                </div>
              ) : amount.beginners && (amount.beginners < 100 || amount.beginners > 999) ? (
                <p className="mt-2 text-sm text-red-500">Please enter between $100-$999</p>
              ) : null}
            </div>
          </div>
        </div>

        {/* Advanced Plan */}
        <div className="bg-white rounded-xl border border-[#000300]/20 overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300 transform hover:scale-[1.01] relative">
          <div className="absolute top-0 left-0 right-0 h-1 bg-[#000300]"></div>
          <div className="p-8">
            <div className="flex justify-between items-start mb-6">
              <h3 className="text-2xl font-medium">ADVANCED</h3>
              <span className="bg-[#000300]/10 text-[#000300] px-3 py-1 rounded-full text-sm font-medium">
                POPULAR
              </span>
            </div>

            <div className="mb-6">
              <p className="text-[#000300]/60 mb-1">Investment Range</p>
              <p className="text-xl">$1,000 - $9,999</p>
            </div>

            <div className="flex justify-between items-center mb-6">
              <div>
                <p className="text-[#000300]/60">ROI Percentage</p>
                <p className="text-2xl">300%</p>
              </div>
              <div>
                <p className="text-[#000300]/60">Duration</p>
                <p>15 Days</p>
              </div>
            </div>

            <div className="mb-6">
              <p className="text-[#000300]/80 text-sm mb-3">
                For serious investors. Example: Invest $2,000 and get $6,000 profit (300% ROI), totaling $8,000 returned after 15 days.
              </p>
            </div>

            <div className="mb-6">
              <div className="flex items-center justify-between mb-2">
                <label className="block text-[#000300]/60">Calculate Your Potential Return</label>
                <span className="text-xs bg-[#000300]/5 px-2 py-1 rounded">Try any amount!</span>
              </div>
              <div className="relative">
                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#000300]/50">$</span>
                <input
                  type="number"
                  value={amount.advanced}
                  onChange={(e) => handleInputChange(e, 'advanced')}
                  className="w-full bg-white border border-[#000300]/20 rounded-lg px-8 py-3 focus:ring-1 focus:ring-[#000300] focus:border-transparent placeholder-[#000300]/30"
                  placeholder="e.g. 2000"
                />
              </div>
              {amount.advanced >= 1000 && amount.advanced <= 9999 ? (
                <div className="mt-3 p-3 bg-[#000300]/5 rounded-lg border border-[#000300]/10">
                  <p className="text-sm font-medium text-[#000300]">Your Calculation:</p>
                  <p className="text-sm mt-1">
                    <span className="font-medium">Investment:</span> ${amount.advanced}<br />
                    <span className="font-medium">Profit (300%):</span> +${calculateROI(amount.advanced, 300)}<br />
                    <span className="font-medium text-[#000300]">Total Return:</span> <span className="font-bold">${(+amount.advanced + +calculateROI(amount.advanced, 300)).toFixed(2)}</span>
                  </p>
                </div>
              ) : amount.advanced && (amount.advanced < 1000 || amount.advanced > 9999) ? (
                <p className="mt-2 text-sm text-red-500">Please enter between $1,000-$9,999</p>
              ) : null}
            </div>
          </div>
        </div>

        {/* Premium Plan */}
        <div className="bg-white rounded-xl border border-[#000300]/10 overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
          <div className="p-8">
            <div className="flex justify-between items-start mb-6">
              <h3 className="text-2xl font-medium">PREMIUM</h3>
              <span className="bg-[#000300]/5 text-[#000300]/90 px-3 py-1 rounded-full text-sm border border-[#000300]/10">
                VIP
              </span>
            </div>

            <div className="mb-6">
              <p className="text-[#000300]/60 mb-1">Investment Range</p>
              <p className="text-xl">$10,000 - $100,000</p>
            </div>

            <div className="flex justify-between items-center mb-6">
              <div>
                <p className="text-[#000300]/60">ROI Percentage</p>
                <p className="text-2xl">500%</p>
              </div>
              <div>
                <p className="text-[#000300]/60">Duration</p>
                <p>20 Days</p>
              </div>
            </div>

            <div className="mb-6">
              <p className="text-[#000300]/80 text-sm mb-3">
                For high-net-worth investors. Example: Invest $20,000 and get $100,000 profit (500% ROI), totaling $120,000 returned after 20 days.
              </p>
            </div>

            <div className="mb-6">
              <div className="flex items-center justify-between mb-2">
                <label className="block text-[#000300]/60">Calculate Your Potential Return</label>
                <span className="text-xs bg-[#000300]/5 px-2 py-1 rounded">Try any amount!</span>
              </div>
              <div className="relative">
                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#000300]/50">$</span>
                <input
                  type="number"
                  value={amount.premium}
                  onChange={(e) => handleInputChange(e, 'premium')}
                  className="w-full bg-white border border-[#000300]/10 rounded-lg px-8 py-3 focus:ring-1 focus:ring-[#000300] focus:border-transparent placeholder-[#000300]/30"
                  placeholder="e.g. 20000"
                />
              </div>
              {amount.premium >= 10000 && amount.premium <= 100000 ? (
                <div className="mt-3 p-3 bg-[#000300]/5 rounded-lg border border-[#000300]/10">
                  <p className="text-sm font-medium text-[#000300]">Your Calculation:</p>
                  <p className="text-sm mt-1">
                    <span className="font-medium">Investment:</span> ${amount.premium}<br />
                    <span className="font-medium">Profit (500%):</span> +${calculateROI(amount.premium, 500)}<br />
                    <span className="font-medium text-[#000300]">Total Return:</span> <span className="font-bold">${(+amount.premium + +calculateROI(amount.premium, 500)).toFixed(2)}</span>
                  </p>
                </div>
              ) : amount.premium && (amount.premium < 10000 || amount.premium > 100000) ? (
                <p className="mt-2 text-sm text-red-500">Please enter between $10,000-$100,000</p>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Center Contact Section */}
      <div className="max-w-4xl mx-auto mt-20 text-center pb-20">
        <div className="relative bg-white rounded-2xl p-8 md:p-12 shadow-inner border border-[#000300]/10 overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1 bg-[#000300]"></div>
          
          <h2 className="text-3xl font-bold mb-6 relative z-10">Ready to Invest?</h2>
          <p className="text-[#000300]/80 mb-8 max-w-2xl mx-auto relative z-10">
            These calculations are for demonstration only. Contact our specialists for personalized investment advice.
          </p>
          <Link to="/contact">
          <button onClick={() => window.scrollTo(0, 0)} className="px-8 py-4 bg-[#000300] text-white font-medium rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 relative z-10 flex items-center mx-auto border border-[#000300]/20">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            Contact Us
          </button>
          </Link>
        </div>
      </div>
    </div>
    </>
  );
};

export default Plans;